import type React from 'react';
import { useEffect, useState } from 'react';

interface MaintenanceInfo {
  isActive: boolean;
  message?: string;
  estimatedEndTime?: string;
}

export const MaintenanceBanner: React.FC = () => {
  const [maintenance, setMaintenance] = useState<MaintenanceInfo | null>(null);

  useEffect(() => {
    // Check maintenance status
    const checkMaintenance = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/maintenance-status`);
        if (response.ok) {
          const data = await response.json();
          setMaintenance(data.data);
        }
      } catch (error) {
        console.error('Failed to check maintenance status:', error);
      }
    };

    checkMaintenance();
    // Check every 5 minutes
    const interval = setInterval(checkMaintenance, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  if (!maintenance?.isActive) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-full flex items-center">
            <svg
              className="h-5 w-5 text-yellow-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              role="img"
              aria-label="警告"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <p className="text-sm text-yellow-800">
              <span className="font-medium">メンテナンス中:</span>{' '}
              {maintenance.message || 'システムメンテナンスを実施中です。しばらくお待ちください。'}
              {maintenance.estimatedEndTime && (
                <span className="ml-2">
                  (完了予定時刻: {new Date(maintenance.estimatedEndTime).toLocaleString('ja-JP')})
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
